module.exports = __webpack_public_path__ + "static/media/empty_state_graph_list.603d1eb1.png";